import axios from 'axios';

import { PARTNER_PORTAL_FQDN } from '@/services/connections.service';
import { getAuthToken } from '@/services/identity.service';

axios.defaults.headers = {
  'content-type': 'application/json',
  'x-origin-domain': PARTNER_PORTAL_FQDN
};

const convertStatusCodeToBoolean = (statusCode) => {
  if (!statusCode) return false;
  return Number(statusCode) >= 200 && Number(statusCode) < 300;
};

const handleResponse = (response) => {
  const apiResponse = response?.data;

  return {
    data: apiResponse ?? null,
    headers: response?.headers,
    status: convertStatusCodeToBoolean(response?.status),
    statusCode: response?.status,
    statusText: response?.statusText,
    success: true,
    ...apiResponse
  };
};

const handleError = (error) => {
  const apiResponse = error?.response?.data;

  return {
    data: apiResponse ?? null,
    headers: error?.response?.headers ?? null,
    message: error?.message ?? 'Failed to fetch data',
    status: convertStatusCodeToBoolean(error?.response?.status),
    statusCode: error?.response?.status,
    statusText: error?.response?.statusText,
    success: false,
    ...apiResponse
  };
};

export const postWithoutAuth = async (url, entity) => {
  try {
    const response = await axios.post(url, entity);
    return handleResponse(response);
  } catch (error) {
    return handleError(error);
  }
};

export const getWithoutAuth = (url) =>
  axios.get(url).then(handleResponse).catch(handleError);

const getOptionsForWithAuth = () => {
  const token = getAuthToken();
  const headers = {
    'x-access-token': token
  };
  return { headers, withCredentials: true };
};

export const getWithAuth = async (url) => {
  const withAuthOptions = getOptionsForWithAuth();
  try {
    const response = await axios.get(url, withAuthOptions);
    return handleResponse(response);
  } catch (error) {
    return handleError(error);
  }
};

export const postWithAuth = async (url, entity) => {
  const withAuthOptions = getOptionsForWithAuth();
  try {
    const response = await axios.post(url, entity, withAuthOptions);
    return handleResponse(response);
  } catch (error) {
    return handleError(error);
  }
};

export const putWithAuth = async (url, entity) => {
  const withAuthOptions = getOptionsForWithAuth();
  try {
    const response = await axios.put(url, entity, withAuthOptions);
    return handleResponse(response);
  } catch (error) {
    return handleError(error);
  }
};

export const patchWithAuth = async (url, entity) => {
  const withAuthOptions = getOptionsForWithAuth();
  try {
    const response = await axios.patch(url, entity, withAuthOptions);
    return handleResponse(response);
  } catch (error) {
    return handleError(error);
  }
};
